import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { CustomFieldProps, DynamicField, FieldVariant, FileFieldProps } from '@/components/form-builder/form-builder.types';
import { PreviewPdfComponent } from '@/components/shared/preview-pdf/preview-pdf.component';
import { MeetingRepository } from '@/store/meeting-state/meeting-state.repository';
import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload';
import { finalize, map, of, switchMap } from 'rxjs';

interface getPVUploadDialogProps {
  store: MeetingRepository;
  validate: () => void;
}

export const getPVUploadDialog = ({ store, validate }: getPVUploadDialogProps): DialogObject => {
  let currentObjectUrl: string | null = null;
  const fileField: DynamicField<FileFieldProps> = {
    label: 'Modèle PV',
    variant: FieldVariant.FILE,
    isRequired: true,
    props: {
      mode: 'basic',
      accept: 'application/pdf',
      multiple: false,
      value: store.getNestedObservable<File[]>('upload', 'modelPvFile'),
      onFileSelect: (event: FileSelectEvent) => {
        store.setNested('upload', 'modelPvFile', event.currentFiles);
      },
      onFileRemoved: (event: FileRemoveEvent) => {
        store.setNested(
          'upload',
          'modelPvFile',
          store.getNested<File[]>('upload', 'modelPvFile').filter(file => file.name !== event.file.name)
        );
      },
      message: 'common.files.warn',
    },
  };

  const filePreviewField: DynamicField<CustomFieldProps> = {
    label: 'Aperçu du fichier',
    variant: FieldVariant.CUSTOM,
    isHidden: store.getNestedObservable<File[]>('upload', 'modelPvFile').pipe(map((files: File[]) => !files || files.length === 0)),
    props: {
      component: PreviewPdfComponent,
      injectKeys: ['src'],
      src: store.getNestedObservable<File[]>('upload', 'modelPvFile').pipe(
        switchMap((files: File[]) => {
          if (currentObjectUrl) {
            URL.revokeObjectURL(currentObjectUrl);
            currentObjectUrl = null;
          }

          if (!files || files.length === 0) {
            return of('');
          }

          const file = files[0];
          const url = URL.createObjectURL(file);
          currentObjectUrl = url;
          return of(url);
        }),
        finalize(() => {
          if (currentObjectUrl) {
            URL.revokeObjectURL(currentObjectUrl);
            currentObjectUrl = null;
          }
        })
      ),
    },
  };

  return {
    title: 'Télécharger Pv Signé',
    actions: [
      {
        label: 'meeting.actions.upload',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    width: '80%',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: {
          title: '',
          description: '',
          isHeaderHidden: true,
          class: '',
          grids: [
            {
              title: '',
              isHeaderHidden: true,
              gridItems: [
                {
                  fields: [fileField],
                },
                {
                  fields: [filePreviewField],
                },
              ],
            },
          ],
        },
      },
    },
  };
};
